export const GOOGLE_ANALYTICS_ID = "G-2VT4KV68X7";
